import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { GalleryDto, Section } from '@nusign/picflow-backend-types';
import { calcColumnCount } from '../../../lib/calc-column-count';
import { seededRandom } from '../../../lib/seeded-random';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { RoundedHoverBoxComponent } from '../rounded-hover-box/rounded-hover-box.component';

@Component({
  selector: 'app-layout-preview',
  imports: [RoundedHoverBoxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './layout-preview.component.html',
  styleUrl: './layout-preview.component.scss',
})
export class LayoutPreviewComponent {
  gallery = input.required<GalleryDto>();
  theme = computed(() => {
    if (!this.gallery()) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });

  rows = computed(() => {
    const theme = this.theme();
    const rows = theme.section.grid_layout === 'rows';
    const columnCount = rows ? 5 : calcColumnCount(<Section>{}, theme);
    const rowCount = rows ? calcColumnCount(<Section>{}, theme) : 5;

    return Array.from({ length: columnCount }).map((_, i) => {
      return Array.from({ length: rowCount }).map((_, j) => {
        if (seededRandom(`row_${i}_${j}`) > 0.5) return 'vertical';
        return 'horizontal';
      });
    });
  });
}
